// Port of api/fuel/app/classes/filter/package/games/play/prepare/games/players/user.php
import F from 'offline/filter/constants'
export default {
	require: function(config, filter) { return config.ownerType === F.OWNER_USER && filter.play && filter.play.group },
	run: function(local, global) {
		local.players = []
		var players = (global.players && global.players[local.game_id]) ? global.players[local.game_id] : []

		for (var i = 0; i < players.length; i++) {
			var player = players[i]
			if (!player) continue
			local.players.push({
				id: parseInt(player.u, 10) || 0,
				name: player.n || player.un || '',
				plays: parseInt(player.p, 10) || 0,
				results: parseInt(player.r, 10) || 0,
				wins: parseInt(player.w, 10) || 0
			})
		}

		local.record = (global.record && global.record[local.game_id]) ? global.record[local.game_id] : {}
		return local
	}
}
